import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const WhyTimeExtendedModalContent = ({
    requestedStart,
    requestedEnd,
    rate
}) => {
    const DATE_FORMAT = 'MMM D';
    const TIME_FORMAT = 'h:mm a';
    const reservationStartObj = moment(rate.starts);
    const reservationEndObj = moment(rate.ends);
    const requestedStartObj = moment(requestedStart);
    const requestedEndObj = moment(requestedEnd);
    const reservationDuration = reservationEndObj.diff(reservationStartObj);
    const requestedDuration = requestedEndObj.diff(requestedStartObj);
    const multipleDays = (reservationStartObj
        .clone()
        .startOf('day')
        .diff(reservationEndObj
            .clone()
            .startOf('day'), 'days'
        ) !== 0);
    const reservationStartDateLabel = reservationStartObj.format(DATE_FORMAT);
    const reservationStartTimeLabel = reservationStartObj.format(TIME_FORMAT);
    const reservationEndDateLabel = reservationEndObj.format(DATE_FORMAT);
    const reservationEndTimeLabel = reservationEndObj.format(TIME_FORMAT);
    const requestedStartDateLabel = requestedStartObj.format(DATE_FORMAT);
    const requestedStartTimeLabel = requestedStartObj.format(TIME_FORMAT);
    const requestedEndDateLabel = requestedEndObj.format(DATE_FORMAT);
    const requestedEndTimeLabel = requestedEndObj.format(TIME_FORMAT);
    const requestedPercentageWidth = (requestedDuration / reservationDuration) * 100;
    const resStartDateLabel = (multipleDays) ? reservationStartDateLabel : null;
    const resEndDateLabel = (multipleDays) ? reservationEndDateLabel : null;
    const reqStartDateLabel = (multipleDays) ? requestedStartDateLabel : null;
    const reqEndDateLabel = (multipleDays) ? requestedEndDateLabel : null;
    const tooltipStyles = (multipleDays) ? {top: 54} : {};
    const fillStyles = {
        width: `${requestedPercentageWidth}%`,
        borderLeft: 0
    };

    return (
        <div className="WhyTimeExtendedModalContent">
            <p>It is the same price to park at this spot for a longer time period so we extended your reservation for you. Go nuts!</p>
            <div className="allowed-guide"><span className="guide" /></div>
            <div className="allowed-labels">
                <span className="allowed-label allowed-label-start">Reservation Starts<br />{resStartDateLabel}{multipleDays && <br />}{reservationStartTimeLabel}</span>
                <span className="allowed-label allowed-label-end">Reservation Ends<br />{resEndDateLabel}{multipleDays && <br />}{reservationEndTimeLabel}</span>
            </div>
            <div className="range-scale">
                <div className="allowed-fill">
                    <div
                        className="requested-fill"
                        style={fillStyles}
                    >
                        <span className="requested-label requested-label-start">{reqStartDateLabel}{multipleDays && <br />}{requestedStartTimeLabel}</span>
                        <span className="requested-label requested-label-end">{reqEndDateLabel}{multipleDays && <br />}{requestedEndTimeLabel}</span>
                        <div
                            className="Tooltip Tooltip-no-close Tooltip-bottom Tooltip-showing"
                            role="tooltip"
                            style={tooltipStyles}
                        >
                            <div className="Tooltip-arrow" />
                            <div className="Tooltip-content">What you requested</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

WhyTimeExtendedModalContent.propTypes = {
    requestedStart: PropTypes.string.isRequired,
    requestedEnd: PropTypes.string.isRequired,
    rate: PropTypes.object.isRequired
};

export default WhyTimeExtendedModalContent;
